import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const loginWithCredentials = createAsyncThunk('auth/loginWithCredentials', async (credentials) => {
  const response = await axios.post(`${API_BASE_URL}/api/users/login/`, credentials);
  return response.data;
});

export const loginWithGoogle = createAsyncThunk('auth/loginWithGoogle', async (googleToken) => {
  const response = await axios.post(`${API_BASE_URL}/api/users/login/`, { token: googleToken });
  return response.data;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: null, token: null, isAuthenticated: false },
  reducers: { logout: (state) => { state.user = null; state.isAuthenticated = false; } },
  extraReducers: (builder) => {
    builder.addCase(loginWithCredentials.fulfilled, (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    });
    builder.addCase(loginWithGoogle.fulfilled, (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
